export default __webpack_public_path__ + "static/media/wppIconDark.8654ba54.svg";